import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, Spinner, Dropdown } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const Navigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAuthenticated, isLoading, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="mb-4">
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img 
            src="/pouncer.png"
            alt="Pouncer Logo"
            style={{
              height: '30px',
              width: 'auto',
              marginRight: '8px'
            }}
          />
          <span>Pouncer</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link 
              as={Link}
              to="/"
              className={location.pathname === '/' ? 'active' : ''}
            >
              Home
            </Nav.Link>
            <Nav.Link 
              as={Link}
              to="/about"
              className={location.pathname === '/about' ? 'active' : ''}
            >
              About
            </Nav.Link>
            <Nav.Link 
              as={Link}
              to="/help"
              className={location.pathname === '/help' ? 'active' : ''}
            >
              Help
            </Nav.Link>
            
            {isLoading ? (
              <Nav.Item className="d-flex align-items-center">
                <Spinner animation="border" size="sm" variant="light" />
              </Nav.Item>
            ) : isAuthenticated ? (
              // Authenticated user menu
              <>
                <Nav.Link 
                  as={Link}
                  to="/account"
                  className={location.pathname === '/account' ? 'active' : ''}
                >
                  Account
                </Nav.Link>
                <Dropdown as={Nav.Item} align="end">
                  <Dropdown.Toggle 
                    as={Nav.Link}
                    className="d-flex align-items-center"
                    style={{ cursor: 'pointer' }}
                  >
                    👤 {user?.first_name || user?.email || 'Account'}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item disabled>
                      <small className="text-muted">
                        {user?.email}
                      </small>
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item as={Link} to="/account">
                      ⚙️ Account Settings
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={handleLogout}>
                      🚪 Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </>
            ) : (
              // Unauthenticated user menu
              <>
                <Nav.Link 
                  as={Link}
                  to="/login"
                  className={location.pathname === '/login' ? 'active' : ''}
                >
                  Login
                </Nav.Link>
                <Nav.Link 
                  as={Link}
                  to="/register"
                  className={location.pathname === '/register' ? 'active' : ''}
                >
                  Register
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
